<mat-form-field>
    <mat-select [placeholder]="placeholder" [(ngModel)]="selection" name="select-company"
        (selectionChange)="onSelectionChnaged()" [disabled]="isDisabled"> 
        <mat-option [value]="0" *ngIf="showAll" >{{ "All" | localize }}</mat-option>
        <mat-option *ngFor="let entity of dataSource" [value]="entity.id">
            {{ entity.code }}
        </mat-option>
    </mat-select>
</mat-form-field>